import React, { useState } from 'react';
import { dariAlphabet } from './dariAlphabet';
import LetterCard from './LetterCard';
import LetterQuiz from './LetterQuiz';
import { markLessonComplete } from './letterProgress';

function infoFor(dari) {
  return dariAlphabet.find((l) => l.dari === dari);
}

// One lesson: teach phase (cards) → quiz phase → result.
function LessonPage({ lesson, recordedSet, onBack, onNext, hasNext }) {
  const [phase, setPhase] = useState('teach'); // 'teach' | 'quiz' | 'done'
  const [score, setScore] = useState(0);
  const letters = lesson.letters.map(infoFor).filter(Boolean);

  const handleComplete = (pct) => {
    setScore(pct);
    markLessonComplete(lesson.id, pct);
    setPhase('done');
  };

  return (
    <div className='lesson'>
      <div className='lesson-head'>
        <button type='button' className='nav-link' onClick={onBack}>← All lessons</button>
        <h2 className='lesson-title'>{lesson.title}</h2>
      </div>

      {phase === 'teach' && (
        <>
          {lesson.note && <p className='lesson-note'>{lesson.note}</p>}
          {letters.map((L) => (
            <LetterCard key={L.dari} letter={L} recordedSet={recordedSet} />
          ))}
          <button type='button' className='primary-btn' onClick={() => setPhase('quiz')}>
            Start quiz →
          </button>
        </>
      )}

      {phase === 'quiz' && (
        <LetterQuiz letters={lesson.letters} recordedSet={recordedSet} onComplete={handleComplete} />
      )}

      {phase === 'done' && (
        <div className='lesson-result'>
          <div className='result-score'>{score}%</div>
          <p>Lesson complete!</p>
          <div className='result-actions'>
            <button type='button' className='nav-link' onClick={() => setPhase('teach')}>
              Review
            </button>
            {hasNext
              ? <button type='button' className='primary-btn' onClick={onNext}>Next lesson →</button>
              : <button type='button' className='primary-btn' onClick={onBack}>Back to lessons</button>}
          </div>
        </div>
      )}
    </div>
  );
}

export default LessonPage;
